<ng-container *ngIf="env.USE_TAILWIND">
    <p class="pb-4" *ngIf="env.REGISTRATION?.CREATE_ACCOUNT_INFORMATION">
        {{ 'CREATE_ACCOUNT_INFORMATION' | translate }}
    </p>
    <p class="required-text">{{ 'REQUIRED_FIELDS_FORM_TITLE' | translate }}</p>
    <ng-container
        [ngTemplateOutlet]="
            env.REGISTRATION?.DISABLE_FOCUS_ON_FORM_INVALID ? formWrapperWithoutFocus : formWrapperWithFocus
        "></ng-container>
</ng-container>
<ng-template #FIRST_NAME>
    <mat-form-field class="full-width" appearance="outline">
        <mat-label
            [attr.aria-label]="
                env.REGISTRATION?.DIVIDED_FIRST_AND_LAST_NAME
                    ? ('PH_FIRST_NAME' | translate)
                    : ('PH_ACCOUNT_NAME' | translate)
            "
            [attr.title]="
                env.REGISTRATION?.DIVIDED_FIRST_AND_LAST_NAME
                    ? ('PH_FIRST_NAME' | translate)
                    : ('PH_ACCOUNT_NAME' | translate)
            ">
            {{
                env.REGISTRATION?.DIVIDED_FIRST_AND_LAST_NAME
                    ? ('PH_FIRST_NAME' | translate)
                    : ('PH_ACCOUNT_NAME' | translate)
            }}
        </mat-label>
        <input
            [formControl]="_registerForm.controls.name"
            [required]="
                !this.registrationOptions.FULL_NAME_IS_OPTIONAL &&
                !this.env.REGISTRATION?.FIELD_ORDER?.FIRST_NAME?.OPTIONAL
            "
            [attr.aria-label]="
                env.REGISTRATION?.DIVIDED_FIRST_AND_LAST_NAME
                    ? ('PH_FIRST_NAME' | translate)
                    : ('PH_ACCOUNT_NAME' | translate)
            "
            [attr.title]="
                env.REGISTRATION?.DIVIDED_FIRST_AND_LAST_NAME
                    ? ('PH_FIRST_NAME' | translate)
                    : ('PH_ACCOUNT_NAME' | translate)
            "
            matInput
            ridangoInput
            name="name"
            type="name"
            ridangoUntouchOnFocusout />
        <mat-error *ngIf="_registerForm.controls.name.hasError('required')">
            {{
                env.REGISTRATION?.FIELD_ORDER?.FIRST_NAME?.VALIDATION?.TRANSLATION_LABELS.BLANK ??
                    'LOCAL_INPUT_VALIDATION_REQUIRED' | translate
            }}
        </mat-error>
    </mat-form-field>
</ng-template>
<ng-template #LAST_NAME>
    <mat-form-field class="full-width text-primary" appearance="outline">
        <mat-label
            aria-label="{{ 'PH_ACCOUNT_LAST_NAME' | translate }}"
            title="{{ 'PH_ACCOUNT_LAST_NAME' | translate }}"
            >{{ 'PH_ACCOUNT_LAST_NAME' | translate }}</mat-label
        >
        <input
            [formControl]="_registerForm.controls.lastName"
            [required]="
                !this.registrationOptions.FULL_NAME_IS_OPTIONAL &&
                !this.env.REGISTRATION?.FIELD_ORDER?.LAST_NAME?.OPTIONAL
            "
            matInput
            ridangoInput
            aria-label="{{ 'PH_ACCOUNT_LAST_NAME' | translate }}"
            title="{{ 'PH_ACCOUNT_LAST_NAME' | translate }}"
            name="lastName"
            type="text"
            ridangoUntouchOnFocusout />
        <mat-error *ngIf="_registerForm.controls.name.hasError('required')">
            {{
                env.REGISTRATION?.FIELD_ORDER?.LAST_NAME?.VALIDATION?.TRANSLATION_LABELS.BLANK ??
                    'LOCAL_INPUT_VALIDATION_REQUIRED' | translate
            }}
        </mat-error>
    </mat-form-field>
</ng-template>
<ng-template #EMAIL>
    <mat-form-field class="full-width" (click)="emailInput.focus()" appearance="outline">
        <mat-label
            aria-hidden="true"
            aria-label="{{ 'LOCAL_LABEL_EMAIL' | translate }}"
            title="{{ 'LOCAL_LABEL_EMAIL' | translate }}"
            >{{ 'PH_EMAIL' | translate }}</mat-label
        >
        <input
            #emailInput
            [formControl]="_registerForm.controls.email"
            [required]="!this.env.REGISTRATION?.FIELD_ORDER?.EMAIL?.OPTIONAL"
            [attr.aria-invalid]="_registerForm.controls.email.invalid && _registerForm.controls.email.touched"
            matInput
            ridangoInput
            pattern="^(?=.{1,256})(?=.{1,64}@.{1,255}$)[A-Za-z0-9._+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,4}$"
            aria-label="{{ 'LOCAL_LABEL_EMAIL' | translate }}"
            title="{{ 'LOCAL_LABEL_EMAIL' | translate }}"
            ridangoAutofill
            type="email"
            name="email"
            autocorrect="on"
            autocomplete="username"
            aria-errormessage="email-error" />
        <mat-hint class="text-base" id="signup-email-hint">{{ 'LOCAL_INPUT_HINT_EMAIL' | translate }}</mat-hint>
        <mat-error id="email-error" aria-live="polite">
            <ng-container *ngIf="_registerForm.controls.email.hasError('required')">
                {{
                    env.REGISTRATION?.FIELD_ORDER?.EMAIL?.VALIDATION?.TRANSLATION_LABELS.BLANK ??
                        'LOCAL_INPUT_EMAIL_MISSING' | translate
                }}
            </ng-container>
            <ng-container
                *ngIf="
                    (_registerForm.controls.email.hasError('email') &&
                        !_registerForm.controls.email.hasError('required')) ||
                    _registerForm.controls.email.hasError('pattern')
                ">
                {{
                    env.REGISTRATION?.FIELD_ORDER?.FIRST_NAME?.VALIDATION?.TRANSLATION_LABELS.CUSTOM ??
                        'LOCAL_INPUT_VALIDATION_EMAIL' | translate
                }}
            </ng-container>
        </mat-error>
    </mat-form-field>
</ng-template>
<ng-template #PASSWORD>
    <mat-form-field class="full-width" (click)="passwordInput.focus()" appearance="outline">
        <mat-label
            aria-hidden="true"
            aria-label="{{ 'PH_PASSWORD' | translate }}"
            title="{{ 'PH_PASSWORD' | translate }}"
            >{{ 'PH_PASSWORD' | translate }}</mat-label
        >
        <input
            #passwordInput
            [type]="hide ? 'password' : 'text'"
            [formControl]="_registerForm.controls.password"
            [required]="true"
            aria-label="{{ 'PH_PASSWORD' | translate }}"
            title="{{ 'PH_PASSWORD' | translate }}"
            matInput
            ridangoInput
            ridangoAutofill
            type="password"
            name="password"
            autocomplete="new-password"
            ridangoUntouchOnFocusout />
        <div class="mr-3 flex items-center justify-center gap-5" matSuffix>
            <button
                class="orb-app-light:text-secondary gl-light:text-[var(--color-secondary)] text-primary"
                [attr.aria-label]="
                    hide ? ('SHOW_PASSWORD_ARIA_LABEL' | translate) : ('HIDE_PASSWORD_ARIA_LABEL' | translate)
                "
                (click)="togglePassword()"
                matSuffix
                type="button">
                <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            <img
                *ngIf="showGreenCheck && _registerForm.get('password').valid"
                src="{{ assetsPath$ | async }}/check_green.svg" />
        </div>

        <mat-hint>
            <ridango-ui-mat-list-hint
                titleTerm="PASSWORD_REQUIREMENT_HINT_TITLE"
                listTerm="PASSWORD_REQUIREMENT_HINT_LIST">
            </ridango-ui-mat-list-hint>
        </mat-hint>

        <mat-error
            *ngIf="_registerForm.controls.password.touched"
            [ngSwitch]="getFirstError(_registerForm.controls.password, ['required', 'minlength', 'numberRequired'])">
            <ng-container *ngSwitchCase="'required'">
                {{
                    env.REGISTRATION?.FIELD_ORDER?.PASSWORD?.VALIDATION?.TRANSLATION_LABELS.BLANK ??
                        'LOCAL_INPUT_VALIDATION_REQUIRED' | translate
                }}
            </ng-container>
            <ng-container *ngSwitchCase="'minlength'">
                {{
                    env.REGISTRATION?.FIELD_ORDER?.PASSWORD?.VALIDATION?.TRANSLATION_LABELS.MIN_LENGTH ??
                        'LOCAL_INPUT_VALIDATION_MIN_LENGTH' | translate
                }}
            </ng-container>
            <ng-container *ngSwitchCase="'numberRequired'">
                {{
                    env.REGISTRATION?.FIELD_ORDER?.PASSWORD?.VALIDATION?.TRANSLATION_LABELS.CUSTOM ??
                        'LOCAL_INPUT_PASSWORD_MISSING_NUMBER_LENGTH' | translate
                }}
            </ng-container>
        </mat-error>
    </mat-form-field>
</ng-template>
<ng-template #CONFIRM_PASSWORD>
    <mat-form-field class="full-width" (click)="confirmPasswordInput.focus()" appearance="outline">
        <mat-label
            aria-hidden="true"
            aria-label="{{ 'CONFIRM_PASSWORD' | translate }}"
            title="{{ 'CONFIRM_PASSWORD' | translate }}"
            >{{ 'CONFIRM_PASSWORD' | translate }}</mat-label
        >
        <input
            #confirmPasswordInput
            [type]="hideConfirm ? 'password' : 'text'"
            [formControl]="_registerForm.controls.confirmPassword"
            [required]="true"
            aria-label="{{ 'CONFIRM_PASSWORD' | translate }}"
            title="{{ 'CONFIRM_PASSWORD' | translate }}"
            matInput
            ridangoInput
            type="password"
            name="confirm-password"
            autocomplete="new-password"
            ridangoUntouchOnFocusout />
        <div class="mr-3 flex items-center justify-center gap-5" matSuffix>
            <button
                class="orb-app-light:text-secondary gl-light:text-[var(--color-secondary)] text-primary"
                [attr.aria-label]="
                    hideConfirm
                        ? ('SHOW_CONFIRM_PASSWORD_ARIA_LABEL' | translate)
                        : ('HIDE_CONFIRM_PASSWORD_ARIA_LABEL' | translate)
                "
                (click)="toggleConfirmPassword()"
                matSuffix
                type="button">
                <mat-icon>{{ hideConfirm ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            <img
                *ngIf="showGreenCheck && _registerForm.get('confirmPassword').valid"
                src="{{ assetsPath$ | async }}/check_green.svg" />
        </div>
        <mat-error *ngIf="_registerForm.controls.confirmPassword.hasError('valueMatch')">
            {{
                env.REGISTRATION?.FIELD_ORDER?.CONFIRM_PASSWORD?.VALIDATION?.TRANSLATION_LABELS.CUSTOM ??
                    'LOCAL_PASSWORDS_MUST_MATCH' | translate
            }}
        </mat-error>
        <mat-error *ngIf="_registerForm.controls.confirmPassword.hasError('required')">
            {{
                env.REGISTRATION?.FIELD_ORDER?.CONFIRM_PASSWORD?.VALIDATION?.TRANSLATION_LABELS.BLANK ??
                    'RE_ENTER_PASSWORD' | translate
            }}
        </mat-error>
    </mat-form-field>
</ng-template>
<ng-template #PERSONAL_CODE>
    <mat-form-field class="full-width" appearance="outline">
        <mat-label aria-label="{{ 'PERSONAL_CODE' | translate }}" title="{{ 'PERSONAL_CODE' | translate }}">{{
            'PERSONAL_CODE' | translate
        }}</mat-label>
        <input
            [formControl]="_registerForm.controls.personalCode"
            [required]="!this.env.REGISTRATION?.FIELD_ORDER?.PERSONAL_CODE?.OPTIONAL"
            matInput
            ridangoInput
            aria-label="{{ 'PERSONAL_CODE' | translate }}"
            title="{{ 'PERSONAL_CODE' | translate }}"
            name="personalCode"
            type="text"
            inputmode="numeric"
            ridangoUntouchOnFocusout />

        <mat-hint id="signup-password-hint" *ngIf="!this.env.REGISTRATION?.FIELD_ORDER?.PERSONAL_CODE?.OPTIONAL">
            <ridango-ui-mat-list-hint
                titleTerm="PERSONAL_CODE_REQUIREMENT_HINT_TITLE"
                listTerm="PERSONAL_CODE_REQUIREMENT_HINT_LIST">
            </ridango-ui-mat-list-hint>
        </mat-hint>
        <mat-error *ngIf="_registerForm.controls.personalCode.hasError('required')">
            {{
                env.REGISTRATION?.FIELD_ORDER?.PERSONAL_CODE?.VALIDATION?.TRANSLATION_LABELS.BLANK ??
                    'LOCAL_INPUT_VALIDATION_REQUIRED' | translate
            }}
        </mat-error>
        <mat-error *ngIf="_registerForm.controls.personalCode.hasError('pattern')">
            {{
                env.REGISTRATION?.FIELD_ORDER?.PERSONAL_CODE?.VALIDATION?.TRANSLATION_LABELS.CUSTOM ??
                    'REGISTRATION_PATTERN_PERSONAL_CODE_VALIDATION' | translate
            }}
        </mat-error>
    </mat-form-field>
</ng-template>
<ng-template #PHONE_NUMBER>
    <mat-form-field class="full-width" (click)="phoneNumberInput.focus()" appearance="outline">
        <mat-label aria-label="{{ 'PHONE_NUMBER' | translate }}" title="{{ 'PHONE_NUMBER' | translate }}">
            {{ 'PHONE_NUMBER' | translate }}
        </mat-label>
        <input
            #phoneNumberInput
            [formControl]="_registerForm.controls.phoneNumber"
            [required]="!this.env.REGISTRATION?.FIELD_ORDER?.PHONE_NUMBER?.OPTIONAL"
            [attr.aria-invalid]="
                _registerForm.controls.phoneNumber.invalid && _registerForm.controls.phoneNumber.touched
            "
            matInput
            ridangoInput
            aria-label="{{ 'PHONE_NUMBER' | translate }}"
            title="{{ 'PHONE_NUMBER' | translate }}"
            name="phoneNumber"
            type="tel"
            inputmode="tel"
            ridangoUntouchOnFocusout
            aria-errormessage="phone-error" />
        <mat-error id="phone-error" aria-live="polite">
            <ng-container *ngIf="_registerForm.controls.phoneNumber.hasError('required')">
                {{
                    env.REGISTRATION?.FIELD_ORDER?.PHONE_NUMBER?.VALIDATION?.TRANSLATION_LABELS.BLANK ??
                        'LOCAL_INPUT_VALIDATION_REQUIRED' | translate
                }}
            </ng-container>
            <ng-container *ngIf="_registerForm.controls.phoneNumber.hasError('phoneTooShort')">
                {{ 'LOCAL_INPUT_VALIDATION_PHONE_TOO_SHORT' | translate }}
            </ng-container>
            <ng-container *ngIf="_registerForm.controls.phoneNumber.hasError('phoneTooLong')">
                {{ 'LOCAL_INPUT_VALIDATION_PHONE_TOO_LONG' | translate }}
            </ng-container>
            <ng-container *ngIf="_registerForm.controls.phoneNumber.hasError('invalidPhoneCountryCode')">
                {{ 'LOCAL_INPUT_VALIDATION_PHONE_INVALID_COUNTRY_CODE' | translate }}
            </ng-container>
            <ng-container *ngIf="_registerForm.controls.phoneNumber.hasError('invalidPhoneNumber')">
                {{
                    env.REGISTRATION?.FIELD_ORDER?.PHONE_NUMBER?.VALIDATION?.TRANSLATION_LABELS.CUSTOM ??
                        'REGISTRATION_PHONE_NUMBER_PATTERN_VALIDATION' | translate
                }}
            </ng-container>
        </mat-error>
    </mat-form-field>
</ng-template>

<ng-template #formWrapperWithFocus>
    <form #signupForm [formGroup]="_registerForm" (ngSubmit)="register()" autocomplete="on">
        <ng-container [ngTemplateOutlet]="fieldOrderKeys ? formContentOrdered : formContent"></ng-container>
    </form>
</ng-template>

<ng-template #formWrapperWithoutFocus>
    <form #signupForm [formGroup]="_registerForm" (ngSubmit)="register()" autocomplete="on">
        <ng-container [ngTemplateOutlet]="fieldOrderKeys ? formContentOrdered : formContent"></ng-container>
    </form>
</ng-template>

<ng-template #formContent>
    <ng-container *ngIf="!env.REGISTRATION?.DIVIDED_FIRST_AND_LAST_NAME" [ngTemplateOutlet]="EMAIL"></ng-container>
    <ng-container *ngIf="registrationOptions.DISPLAY_FULL_NAME_FIELD" [ngTemplateOutlet]="FIRST_NAME"></ng-container>

    <ng-container
        *ngIf="env.REGISTRATION?.DIVIDED_FIRST_AND_LAST_NAME && registrationOptions.DISPLAY_FULL_NAME_FIELD"
        [ngTemplateOutlet]="LAST_NAME"></ng-container>

    <ng-container *ngIf="env.REGISTRATION?.DIVIDED_FIRST_AND_LAST_NAME" [ngTemplateOutlet]="EMAIL"></ng-container>

    <ng-container [ngTemplateOutlet]="PASSWORD"></ng-container>
    <ng-container [ngTemplateOutlet]="CONFIRM_PASSWORD"></ng-container>

    <div class="border-t border-solid border-grey-white_smoke pt-4 dark:border-contrast-yellow">
        <div class="item-tnc" *ngIf="_terms">
            <span class="checkbox-wcag">
                <input
                    class="checkbox-wcag__checkbox"
                    [formControl]="_registerForm.controls.terms"
                    type="checkbox"
                    aria-hidden="true"
                    required
                    tabindex="-1"
                    attr.aria-label="{{ 'READ_TERMS' | translate }} {{ 'WITH_TERMS_AND_CONDITIONS' | translate }} {{
                        'ASTERISK' | translate
                    }}" />

                <span
                    class="checkbox-wcag__checkmark"
                    (click)="toggleCheckbox('terms')"
                    (keydown.enter)="toggleCheckbox('terms')"
                    (keydown.space)="toggleCheckbox('terms')"
                    tabindex="0"
                    attr.aria-checked="{{ _termsAgreed }}"
                    role="checkbox"
                    required
                    attr.aria-label="{{ 'READ_TERMS' | translate }} {{ 'WITH_TERMS_AND_CONDITIONS' | translate }} {{
                        'ASTERISK' | translate
                    }}">
                </span>

                <label class="checkbox-wcag__label">
                    <span class="text-left text-base font-medium">
                        <span
                            class="link-label"
                            (click)="toggleCheckbox('terms')"
                            (keydown.enter)="toggleCheckbox('terms')"
                            (keydown.space)="toggleCheckbox('terms')">
                            {{ 'READ_TERMS' | translate }}
                        </span>

                        <a
                            class="pn-app-light:text-primary pn-light:text-primary text-secondary"
                            #modalTrigger
                            (click)="openTermsModalClick()"
                            (keydown.enter)="openTermsModalClick()"
                            (keydown.space)="openTermsModalClick()"
                            tabindex="0"
                            role="link">
                            {{ 'WITH_TERMS_AND_CONDITIONS' | translate }}.*
                        </a>
                    </span>
                </label>
            </span>
        </div>
        <div class="item-tnc" *ngIf="env.REGISTRATION?.PERSONAL_DATA">
            <span class="checkbox-wcag">
                <input
                    class="checkbox-wcag__checkbox"
                    [formControl]="_registerForm.controls.personalData"
                    type="checkbox"
                    aria-hidden="true"
                    required
                    tabindex="-1"
                    attr.aria-label="{{ 'READ_PERSONAL_DATA_CHECKBOX_ARIA_LABEL' | translate }} {{
                        'ASTERISK' | translate
                    }}" />

                <span
                    class="checkbox-wcag__checkmark"
                    (click)="toggleCheckbox('personalData')"
                    (keydown.space)="toggleCheckbox('personalData')"
                    (keydown.enter)="toggleCheckbox('personalData')"
                    tabindex="0"
                    attr.aria-checked="{{ _personalDataAgreed }}"
                    role="checkbox"
                    required
                    attr.aria-label="{{ 'READ_PERSONAL_DATA_CHECKBOX_ARIA_LABEL' | translate }} {{
                        'ASTERISK' | translate
                    }}">
                </span>

                <label class="checkbox-wcag__label">
                    <span class="text-base font-semibold leading-4 text-black dark:text-contrast-yellow">
                        <span
                            class="link-label"
                            (click)="toggleCheckbox('personalData')"
                            (keydown.enter)="toggleCheckbox('personalData')"
                            (keydown.space)="toggleCheckbox('personalData')">
                            {{ 'PERSONAL_DATA_LABEL' | translate }}
                        </span>

                        <a
                            class="pn-app-light:text-primary pn-light:text-primary text-secondary"
                            [href]="env.REGISTRATION?.PERSONAL_DATA_LINK"
                            tabindex="0"
                            target="_blank">
                            {{ 'PERSONAL_DATA_LINK_LABEL' | translate }}
                        </a>
                    </span>
                </label>
            </span>
        </div>

        <div class="item-tnc" *ngIf="registrationOptions.CHECK_GDPR">
            <span class="checkbox-wcag">
                <input
                    class="checkbox-wcag__checkbox"
                    [formControl]="_registerForm.controls.gdpr"
                    type="checkbox"
                    attr.aria-hidden="true"
                    required
                    tabindex="-1"
                    attr.aria-label="{{ 'GDPR_CHECKBOX_ARIA_LABEL' | translate }}" />

                <span
                    class="checkbox-wcag__checkmark"
                    (click)="toggleCheckbox('gdpr')"
                    (keydown.space)="toggleCheckbox('gdpr')"
                    tabindex="0"
                    attr.aria-checked="{{ _gdprAgreed }}"
                    role="checkbox"
                    attr.aria-label="{{ 'GDPR_CHECKBOX_ARIA_LABEL' | translate }}">
                </span>

                <label class="checkbox-wcag__label">
                    <span class="text-xm font-semibold leading-4 text-black dark:text-contrast-yellow">
                        <span
                            class="link-label"
                            (click)="toggleCheckbox('gdpr')"
                            (keydown.enter)="toggleCheckbox('gdpr')"
                            (keydown.space)="toggleCheckbox('gdpr')">
                            {{ 'GDPR_TEXT' | translate }}
                        </span>

                        <a
                            class="pn-app-light:text-primary pn-light:text-primary text-secondary"
                            href="{{ 'GDPR_LINK_URL' | translate }}"
                            target="_blank"
                            tabindex="0"
                            role="link">
                            {{ 'GDPR_LINK' | translate }}
                        </a>
                    </span>
                </label>
            </span>
        </div>

        <button
            class="orb-app-light-dark:h-9 gl-light:bg-secondary vl-app-light:bg-[var(--btn-primary-color)] sr-app-light:bg-[var(--color-secondary)] var-app-light:bg-[var(--color-secondary)] varmland-light:bg-[var(--color-secondary)] mb-9 w-full rounded-lg bg-[var(--color-primary)] py-[1.125rem] shadow-[0px_2px_4px_0px_#0000001A] dark:bg-contrast-yellow dark:text-contrast-black"
            *ngIf="!this.env.REGISTRATION?.USE_ION_BUTTON"
            [ngClass]="{ 'disabled-button': isRegisterButtonDisabled() }"
            [attr.aria-label]="'BTN_REGISTER' | translate"
            [disabled]="isRegisterButtonDisabled()"
            type="submit">
            <ion-label
                class="gl-light:text-[var(--color-primary)] tallinn-light:text-white jk-light:text-white sr-app-light:text-white pn-app-light:text-white pn-light:text-white pn-app-light:text-white text-base font-semibold normal-case text-contrast-black dark:text-contrast-black">
                {{ 'BTN_REGISTER' | translate }}
            </ion-label>
        </button>

        <ion-button
            class="register-web-button mb-9 mr-16 w-64"
            *ngIf="this.env.REGISTRATION?.USE_ION_BUTTON"
            [ngClass]="{ 'disabled-button': isRegisterButtonDisabled() }"
            [disabled]="isRegisterButtonDisabled()"
            [attr.aria-label]="'BTN_REGISTER' | translate"
            type="submit"
            size="large"
            color="secondary">
            <ion-label class="text-base font-semibold normal-case">
                {{ 'BTN_REGISTER' | translate }}
            </ion-label>
        </ion-button>

        <p class="text-lefttext-base mb-8 font-medium">
            <span class="mr-0.5">{{ 'ALREADY_HAVE_AN_ACCOUNT' | translate }}</span>
            <a
                class="pn-app-light:text-primary pn-light:text-primary inline-flex items-center gap-1 text-secondary no-underline"
                [routerLink]="'/login' | localize">
                {{ 'LOG_IN_HERE_LINK' | translate }}
                <ion-icon class="dark:filter-yellow" name="arrow-forward-sharp"></ion-icon>
            </a>
        </p>

        <re-captcha
            #recaptcha
            *ngIf="hasRecaptcha"
            [formControlName]="recaptcha"
            [siteKey]="siteKey"
            (resolved)="resolved($event)">
        </re-captcha>
    </div>
</ng-template>

<ng-template #formContentOrdered>
    <ng-container *ngFor="let fieldKey of this.fieldOrderKeys" [ngTemplateOutlet]="templateMap[fieldKey]">
    </ng-container>

    <div class="border-t border-solid border-grey-white_smoke pt-4 dark:border-contrast-yellow">
        <div class="item-tnc" *ngIf="_terms">
            <span class="checkbox-wcag">
                <input
                    class="checkbox-wcag__checkbox"
                    [checked]="this._termsAgreed"
                    [formControl]="_registerForm.controls.terms"
                    type="checkbox"
                    aria-hidden="true"
                    required
                    tabindex="-1"
                    attr.aria-label="{{ 'READ_TERMS' | translate }} {{ 'WITH_TERMS_AND_CONDITIONS' | translate }} {{
                        'ASTERISK' | translate
                    }}" />

                <span
                    class="checkbox-wcag__checkmark"
                    (click)="toggleCheckbox('terms')"
                    (keydown.enter)="toggleCheckbox('terms')"
                    (keydown.space)="toggleCheckbox('terms')"
                    tabindex="0"
                    attr.aria-checked="{{ _termsAgreed }}"
                    role="checkbox"
                    required
                    attr.aria-label="{{ 'READ_TERMS' | translate }} {{ 'WITH_TERMS_AND_CONDITIONS' | translate }} {{
                        'ASTERISK' | translate
                    }}">
                </span>

                <label class="checkbox-wcag__label">
                    <span
                        class="orb-app-light:text-sm orb-app-light:font-bold orb-app-light:text-[var(--color)] var-app-light-dark:text-sm/4 var-app-light-dark:font-normal text-left text-base font-medium">
                        <span
                            class="link-label"
                            (click)="toggleCheckbox('terms')"
                            (keydown.enter)="toggleCheckbox('terms')"
                            (keydown.space)="toggleCheckbox('terms')">
                            {{ 'READ_TERMS' | translate }}
                        </span>

                        <a
                            class="orb-app-light:text-sm orb-app-light:font-bold pn-app-light:text-primary pn-light:text-primary var-app-light:text-primary inline-flex items-center gap-1 text-secondary"
                            #modalTrigger
                            (click)="openTermsModalClick()"
                            (keydown.enter)="openTermsModalClick()"
                            (keydown.space)="openTermsModalClick()"
                            tabindex="0"
                            role="link">
                            {{ 'WITH_TERMS_AND_CONDITIONS' | translate }}.*
                            <ion-icon
                                class="dark:filter-yellow"
                                *ngIf="env.REGISTRATION.SHOW_ARROW_AFTER_LINK"
                                name="arrow-forward-sharp"></ion-icon>
                        </a>
                    </span>
                </label>
            </span>
        </div>
        <div class="item-tnc" *ngIf="env.REGISTRATION?.PERSONAL_DATA">
            <span class="checkbox-wcag">
                <input
                    class="checkbox-wcag__checkbox"
                    [formControl]="_registerForm.controls.personalData"
                    type="checkbox"
                    aria-hidden="true"
                    required
                    tabindex="-1"
                    attr.aria-label="{{ 'READ_PERSONAL_DATA_CHECKBOX_ARIA_LABEL' | translate }} {{
                        'ASTERISK' | translate
                    }}" />

                <span
                    class="checkbox-wcag__checkmark"
                    (click)="toggleCheckbox('personalData')"
                    (keydown.space)="toggleCheckbox('personalData')"
                    (keydown.enter)="toggleCheckbox('personalData')"
                    tabindex="0"
                    attr.aria-checked="{{ _personalDataAgreed }}"
                    role="checkbox"
                    required
                    attr.aria-label="{{ 'READ_PERSONAL_DATA_CHECKBOX_ARIA_LABEL' | translate }} {{
                        'ASTERISK' | translate
                    }}">
                </span>

                <label class="checkbox-wcag__label">
                    <span class="text-base font-semibold leading-4 text-black dark:text-contrast-yellow">
                        <span
                            class="link-label"
                            (click)="toggleCheckbox('personalData')"
                            (keydown.enter)="toggleCheckbox('personalData')"
                            (keydown.space)="toggleCheckbox('personalData')">
                            {{ 'PERSONAL_DATA_LABEL' | translate }}
                        </span>

                        <a
                            class="pn-app-light:text-primary pn-light:text-primary text-secondary"
                            [href]="env.REGISTRATION?.PERSONAL_DATA_LINK"
                            tabindex="0"
                            target="_blank">
                            {{ 'PERSONAL_DATA_LINK_LABEL' | translate }}
                        </a>
                    </span>
                </label>
            </span>
        </div>

        <div class="item-tnc" *ngIf="registrationOptions.CHECK_GDPR">
            <span class="checkbox-wcag">
                <input
                    class="checkbox-wcag__checkbox"
                    [formControl]="_registerForm.controls.gdpr"
                    type="checkbox"
                    attr.aria-hidden="true"
                    required
                    tabindex="-1"
                    attr.aria-label="{{ 'GDPR_CHECKBOX_ARIA_LABEL' | translate }}" />

                <span
                    class="checkbox-wcag__checkmark"
                    (click)="toggleCheckbox('gdpr')"
                    (keydown.space)="toggleCheckbox('gdpr')"
                    tabindex="0"
                    attr.aria-checked="{{ _gdprAgreed }}"
                    role="checkbox"
                    attr.aria-label="{{ 'GDPR_CHECKBOX_ARIA_LABEL' | translate }}">
                </span>

                <label class="checkbox-wcag__label">
                    <span
                        class="orb-app-light:text-sm orb-app-light:font-bold orb-app-light:text-[var(--color)] text-xm font-semibold leading-4 text-black dark:text-contrast-yellow">
                        <span
                            class="link-label"
                            (click)="toggleCheckbox('gdpr')"
                            (keydown.enter)="toggleCheckbox('gdpr')"
                            (keydown.space)="toggleCheckbox('gdpr')">
                            {{ 'GDPR_TEXT' | translate }}
                        </span>

                        <a
                            class="orb-app-light:text-sm orb-app-light:font-bold pn-app-light:text-primary pn-light:text-primary inline-flex items-center gap-1 text-secondary"
                            href="{{ 'GDPR_LINK_URL' | translate }}"
                            target="_blank"
                            tabindex="0"
                            role="link">
                            {{ 'GDPR_LINK' | translate }}
                            <ion-icon
                                class="dark:filter-yellow"
                                *ngIf="env.REGISTRATION.SHOW_ARROW_AFTER_LINK"
                                name="arrow-forward-sharp"></ion-icon>
                        </a>
                    </span>
                </label>
            </span>
        </div>

        <button
            class="gl-light:bg-secondary vl-app-light:bg-[var(--btn-primary-color)] sr-app-light:bg-[var(--color-secondary)] varmland-light:bg-[var(--color-secondary)] var-app-light:bg-[var(--color-secondary)] mb-9 w-full rounded-lg bg-[var(--color-primary)] py-[1.125rem] shadow-[0px_2px_4px_0px_#0000001A] dark:bg-contrast-yellow dark:text-contrast-black"
            *ngIf="!this.env.REGISTRATION?.USE_ION_BUTTON"
            [ngClass]="{ 'disabled-button': isRegisterButtonDisabled() }"
            [attr.aria-label]="'BTN_REGISTER' | translate"
            [disabled]="isRegisterButtonDisabled()"
            type="submit">
            <ion-label
                class="gl-light:text-[var(--color-primary)] tallinn-light:text-white jk-light:text-white sr-app-light:text-white pn-app-light:text-white pn-light:text-white pn-app-light:text-white text-base font-semibold normal-case text-contrast-black dark:text-contrast-black">
                {{ 'BTN_REGISTER' | translate }}
            </ion-label>
        </button>

        <ion-button
            class="register-web-button mb-9 mr-16 w-64"
            *ngIf="this.env.REGISTRATION?.USE_ION_BUTTON"
            [ngClass]="{ 'disabled-button': isRegisterButtonDisabled() }"
            [disabled]="isRegisterButtonDisabled()"
            [attr.aria-label]="'BTN_REGISTER' | translate"
            type="submit"
            size="large"
            color="secondary">
            <ion-label class="text-base font-semibold normal-case">
                {{ 'BTN_REGISTER' | translate }}
            </ion-label>
        </ion-button>

        <p class="var-app-light-dark:text-xs/4 var-app-light-dark:font-semibold mb-8 text-left text-base font-medium">
            <span class="mr-0.5">{{ 'ALREADY_HAVE_AN_ACCOUNT' | translate }}</span>
            <a
                class="pn-app-light:text-primary pn-light:text-primary var-app-light:text-primary inline-flex items-center gap-1 text-secondary no-underline"
                [routerLink]="'/login' | localize">
                {{ 'LOG_IN_HERE_LINK' | translate }}
                <ion-icon class="dark:filter-yellow" name="arrow-forward-sharp"></ion-icon>
            </a>
        </p>

        <re-captcha
            #recaptcha
            *ngIf="hasRecaptcha"
            [formControlName]="recaptcha"
            [siteKey]="siteKey"
            (resolved)="resolved($event)">
        </re-captcha>
    </div>
</ng-template>
